import { apiRequest } from "@/lib/api";
import {
  getAnalyticsSessionId,
} from "@/lib/analytics";

type PlatformPageViewInput = {
  path: string;
};

export async function trackPlatformPageView({
  path,
}: PlatformPageViewInput): Promise<void> {
  try {
    await apiRequest<{
      registered: number;
    }>(
      "/analytics/platform/events/",
      {
        method: "POST",
        body: JSON.stringify({
          event: "page_view",
          path,
          session_id:
            getAnalyticsSessionId(),
          metadata: {
            source: "platform",
          },
        }),
      },
    );
  } catch {
    // Analytics nunca deve bloquear
    // a navegação da plataforma.
  }
}
